// A quiet strip telling the caretaker their logs are safe: shown when offline,
// or when changes are still waiting to sync. Silent when everything is synced.

import { useT } from "../lib/LocaleContext";

export function OfflineBar({ online, pendingCount }: { online: boolean; pendingCount: number }) {
  const t = useT();
  if (online && pendingCount === 0) return null;

  const offline = !online;
  return (
    <div style={{ ...styles.bar, ...(offline ? styles.offline : styles.syncing) }} role="status">
      <span style={styles.dot} />
      <span>{offline ? t.pwa.offline : t.pwa.pendingSync(pendingCount)}</span>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  bar: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    margin: "10px 16px 0",
    padding: "9px 12px",
    borderRadius: 12,
    fontSize: 13,
    lineHeight: 1.4,
  },
  offline: { background: "var(--bh-attn-soft)", color: "var(--bh-attn)" },
  syncing: { background: "var(--bh-surface-2)", color: "var(--bh-ink-3)" },
  dot: {
    width: 7,
    height: 7,
    borderRadius: 999,
    background: "currentColor",
    flexShrink: 0,
  },
};
